import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { seedDatabaseIfEmpty } from './seed.ts';
import { loadProductionFirebaseConfig } from './firebase.ts';

async function bootstrap() {
  // 1. Asynchronously load live production Firebase config if running on Firebase Hosting
  await loadProductionFirebaseConfig();

  // 2. Seed database if empty using the active database reference (only in sandbox/dev to protect production)
  const isSandboxOrDev = 
    typeof window !== 'undefined' && 
    (window.location.hostname.includes('ais-dev') || 
     window.location.hostname.includes('ais-pre') || 
     window.location.hostname.includes('localhost') || 
     import.meta.env.DEV);

  if (isSandboxOrDev) {
    seedDatabaseIfEmpty().catch(console.error);
  }

  // 3. Render the application
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );

  // 4. Register or unregister Service Worker for PWA installation support
  const isPreviewOrDev = 
    typeof window !== 'undefined' && 
    (window.location.hostname.includes('ais-dev') || 
     window.location.hostname.includes('ais-pre') || 
     window.location.hostname.includes('localhost') || 
     import.meta.env.DEV);

  if (isPreviewOrDev) {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.unregister();
          console.log('Unregistered service worker for preview reliability');
        }
      });
    }
    if (typeof window !== 'undefined' && window.caches) {
      caches.keys().then((names) => {
        for (const name of names) {
          caches.delete(name);
        }
        console.log('Cleared active caches for preview reliability');
      });
    }
  } else {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
          .then((reg) => console.log('Service Worker registered:', reg.scope))
          .catch((err) => console.error('Service Worker registration failed:', err));
      });
    }
  }
}

bootstrap().catch(console.error);
